export const mutations = {
  setSector: function (state, sector) {
    state.sector = sector;
  },
};
